import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Drawer, FixedDrawer } from 'ypf-pas-general-ui-components';

const FilterContainer = forwardRef(
  ({ isPinned, onAnchor, onClose, show, showAnchor, width, title, children, ...props }, ref) => {
    const SelectedFilter = isPinned ? FixedDrawer : Drawer;

    return (
      <SelectedFilter
        onAnchor={onAnchor}
        onClose={onClose}
        ref={isPinned ? ref : null}
        show={show}
        showAnchor={showAnchor}
        title={title}
        width={width}
        {...props}
      >
        {children}
      </SelectedFilter>
    );
  }
);

FilterContainer.displayName = 'FilterContainer';

FilterContainer.propTypes = {
  isPinned: PropTypes.bool,
  onAnchor: PropTypes.func,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  showAnchor: PropTypes.bool,
  width: PropTypes.number,
  title: PropTypes.string,
  children: PropTypes.node.isRequired
};

FilterContainer.defaultProps = {
  isPinned: false,
  onAnchor: () => {},
  onClose: () => {},
  show: false,
  showAnchor: false,
  width: undefined,
  title: ''
};

export default FilterContainer;
